export interface Article {
  slug: string;
  title: string;
  date: string;
  readTime: string;
  excerpt: string;
  category: string;
  isNew: boolean;
  seq: string;
}

export const articlesList: Article[] = [
  {
    slug: "vigorbuy-sheet-guide",
    title: "What Is VigorBuy Sheet? Complete Beginner Guide",
    date: "June 28, 2026",
    readTime: "8 min read",
    excerpt: "Learn everything about the VigorBuy spreadsheet — what it is, how it works, and why thousands of shoppers rely on it daily for trusted seller lists and QC photos.",
    category: "Beginner Guide",
    isNew: true,
    seq: "article-01",
  },
  {
    slug: "find-trusted-sellers-vigorbuy-spreadsheet",
    title: "How to Find Trusted Sellers Using VigorBuy Spreadsheet",
    date: "June 27, 2026",
    readTime: "6 min read",
    excerpt: "Discover the step-by-step process to identify verified sellers in the VigorBuy spreadsheet and avoid scams when shopping online.",
    category: "Seller Guide",
    isNew: true,
    seq: "article-02",
  },
  {
    slug: "vigorbuy-qc-guide-check-product-quality",
    title: "VigorBuy QC Guide: How to Check Product Quality Before Buying",
    date: "June 26, 2026",
    readTime: "7 min read",
    excerpt: "Master the art of reading QC photos in the VigorBuy spreadsheet to ensure you always receive products that match your expectations.",
    category: "Quality Control",
    isNew: true,
    seq: "article-03",
  },
  {
    slug: "vigorbuy-shipping-guide-everything-to-know",
    title: "VigorBuy Shipping Guide: Everything You Need to Know in 2026",
    date: "June 25, 2026",
    readTime: "6 min read",
    excerpt: "Complete shipping guide covering all delivery methods, estimated times, and cost-saving tips referenced in the VigorBuy spreadsheet.",
    category: "Shipping",
    isNew: true,
    seq: "article-04",
  },
  {
    slug: "top-categories-vigorbuy-spreadsheet",
    title: "Top 10 Categories in VigorBuy Spreadsheet You Should Explore",
    date: "June 24, 2026",
    readTime: "5 min read",
    excerpt: "Explore the most popular product categories in the VigorBuy spreadsheet — from shoes and hoodies to accessories and bags.",
    category: "Shopping Tips",
    isNew: false,
    seq: "article-05",
  },
  {
    slug: "vigorbuy-spreadsheet-vs-traditional-shopping",
    title: "VigorBuy Spreadsheet vs Traditional Shopping: Complete Comparison",
    date: "June 23, 2026",
    readTime: "7 min read",
    excerpt: "A detailed side-by-side comparison of using the VigorBuy spreadsheet versus manually searching for products across multiple platforms.",
    category: "Comparison",
    isNew: false,
    seq: "article-06",
  },
  {
    slug: "save-money-vigorbuy-spreadsheet-2026",
    title: "How to Save Money with VigorBuy Spreadsheet in 2026",
    date: "June 22, 2026",
    readTime: "5 min read",
    excerpt: "Practical tips and strategies to maximize your savings by using the VigorBuy spreadsheet for price comparison and seller selection.",
    category: "Money Tips",
    isNew: false,
    seq: "article-07",
  },
  {
    slug: "beginner-mistakes-vigorbuy-spreadsheet",
    title: "5 Beginner Mistakes to Avoid When Using VigorBuy Spreadsheet",
    date: "June 21, 2026",
    readTime: "6 min read",
    excerpt: "Learn the most common pitfalls new users encounter with the VigorBuy spreadsheet and how to avoid them for a smooth shopping experience.",
    category: "Tips & Tricks",
    isNew: false,
    seq: "article-08",
  },
  {
    slug: "vigorbuy-spreadsheet-faq-answered",
    title: "VigorBuy Spreadsheet FAQ: Answering Your Most Common Questions",
    date: "June 20, 2026",
    readTime: "8 min read",
    excerpt: "Comprehensive answers to the most frequently asked questions about the VigorBuy spreadsheet, seller verification, and product categories.",
    category: "FAQ",
    isNew: false,
    seq: "article-09",
  },
  {
    slug: "future-of-vigorbuy-spreadsheet",
    title: "The Future of VigorBuy Spreadsheet: What's Coming Next in 2026",
    date: "June 19, 2026",
    readTime: "5 min read",
    excerpt: "A look ahead at upcoming features, new categories, and community-driven improvements planned for the VigorBuy spreadsheet.",
    category: "Updates",
    isNew: false,
    seq: "article-10",
  },
];